import * as gfunctions from '../../../js/generalFunctions';

CCL.atcxDining = {
  autoload: [
    ['initialDataLoad', $('#xdiningAtcModal').length > 0]
  ],

  firtimeload: true,

  initialDataLoad() {
    $('body').on('click', '.xdining-atc-modal-open-button', (e) => {
      const prodId = $(e.currentTarget).data('productcode');
      this.loadDiningJsonData(prodId);
    });
  },

  initialValuesTimeDay() {
    const selectDay = $('#select-day');
    const selectTime = $('#select-time');
    const dayValue = selectDay.find('> span').text();
    const timeValue = selectTime.find('> span').text();

    setTimeout(() => {
      selectDay.attr('aria-label', `Select day: ${dayValue} selected`);
      selectTime.attr('aria-label', `Select time: ${timeValue} selected`);
    }, 200);
  },

  loadDiningJsonData(prodId) {
    const token = $('#csrfSessionToken').data('csrf');
    let ajaxUrl = '';
    let ajaxType = '';
    const dataObj = { productCode: prodId };
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/xdining-atc-modal.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/cart/clp/modal';
      ajaxType = 'POST';
    }
    gfunctions.showLoader();
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      data: JSON.stringify(dataObj),
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      this.loadHtmlTamplate(response);
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while fetching data');
    });
  },

  loadHtmlTamplate(jsonData) {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/xdining-atc-modal/xdining-atc-modal.html'
    }).done((response) => {
      const html = gfunctions.createDynamicHTML(response, jsonData);
      $('#dynamicxDiningAtcModal').empty().append(html);
      gfunctions.showModal('xdiningAtcModal');
      // CCL.Dining.priceShow();
      // if (this.firtimeload === true) {
      //   CCL.xDining.toggleDayTime();
      //   CCL.xDining.addToCartDining();
      //   this.firtimeload = false;
      // }

      CCL.xDining.dropdownSelect();
      this.modalEvents();
      this.initialValuesTimeDay();
      gfunctions.pdpGetSelectedData();
      gfunctions.checkboxCheck();

      setTimeout(() => {
        if ($(`#${jsonData.buyerId}`).length) {
          $(`#${jsonData.buyerId}`).trigger('click');
        }
      }, 500);
      // $(`#${jsonData.buyerId}`)[0].checked = true;
      // $(`#${jsonData.buyerId}`).closest('.stateroom-check')[0].firstElementChild.checked = true;
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while loading html');
    });
  },

  modalEvents() {
    const modalEl = $('#diningAtcModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-xdining-atc-modal/xdining-atc-modal.js